import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const ErrorMsg = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: ${tokens.color.error.main};
`
